import { handlePseudoRoute } from "~/utils/pseudo-route-handler";

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return;

  const pseudoLoginStore = usePseudoLogin();

  return await handlePseudoRoute(to, {
    abort: () => abortNavigation(),
    activatePseudo: (pseudoId) => pseudoLoginStore.setPseudoId(pseudoId),
    clearPseudoContexts: () => {
      pseudoLoginStore.setPseudoId(undefined);
      useTeacherPesudoStudentLogin().clearPseudoStudentId();
    },
    getSystemAdminStatus: async () => {
      try {
        const user = await useAuthUser().getUser();

        if (!user) return undefined;

        const claims = await user.getIdTokenResult(true);
        return claims.claims.isSystemAdmin === true;
      } catch {
        return false;
      }
    },
    navigateToLogin: (redirect) =>
      navigateTo({
        path: "/auth/login",
        query: { redirect },
      }),
    origin: window.location.origin,
    replaceLocation: (url) => window.location.replace(url),
  });
});
